import angular from 'angular';
import confirmCloseModalComponent from './confirmCloseModal.component';

let confirmCloseModalModule = angular.module('confirmCloseModal', [])

.component('confirmCloseModal', confirmCloseModalComponent)

.name;

export default confirmCloseModalModule;



// WEBPACK FOOTER //
// ./client/app/components/confirmCloseModal/confirmCloseModal.js